<template>
    <div id="konfigurator-hmotnostkondice">

        <h1>Zadejte aktuální hmotnost</h1>
        <span :class="{'is-refreshed' : refreshWeight}"></span>
        <div v-show="(!isValidHmotnost() || !isKondiceValid()) && this.tryescape" class="info-messages-box">
            <div v-if="!isValidHmotnost() && this.tryescape" class="error-msg">Musíte vybrat hmotnost vašeho mazlíčka
            </div>
            <div v-if="!isKondiceValid() && this.tryescape" class="error-msg">Musíte vybrat kondici vašeho mazlíčka
            </div>
        </div>

        <div class="form-content"
             v-bind:class="{ 'has-error':!isValidHmotnost() && this.tryescape,'has-success':isValidHmotnost() && this.tryescape }">

            <div class="input-blok input-vaha">
                <!--<vue-numeric-->
                <!--min="0"-->
                <!--max="100"-->
                <!--separator="."-->
                <!--v-bind:minus="false"-->
                <!--v-bind:precision="1"-->
                <!--placeholder="Doplňte, jakou má  hmotnost"-->
                <!--v-model="mazlicek.hmotnostkondice.hmotnost"-->
                <!--class="form-control"-->
                <!--&gt;</vue-numeric>-->
                <input class="form-control form-control-vaha" v-model="petWeight" type="number"
                       placeholder="Zadejte váhu svého mazlíčka" min="0" max="100"/>
                <div class="form-type-select select-jednotky">
                    <div class="select-content">
                        <select class="form-select" v-model="mazlicek.hmotnostkondice.hmotnostJednostka">
                            <option value="kg">kg</option>
                            <option value="lb">lb</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="alert alert-info" v-show="!mazlicek.jeStene && !this.checkPrumHmotnost">
                <p>Jste si opravdu jistí váhou vašeho mazlíčka?</p>
            </div>
            <div v-if="!mazlicek.jeStene" class="hmotnost-kondice-title">Určete poctivě, v jaké je teď kondici</div>

            <div v-if="!mazlicek.jeStene" class="form-radios"
                 v-bind:class="{ 'has-error':!isKondiceValid() && this.tryescape }">
                <div class="form-type-radio" :key="key" v-for="(item, key) in kondiceItems">
                    <input type="radio" v-model="mazlicek.hmotnostkondice.kondice" v-bind:value="item.id" :id="item.id"
                           placeholder="Zadejte váhu svého mazlíčka">
                    <label :for="item.id">
                        <div class="item-title">{{ item.title }}</div>
                        <div v-if="item.description.length > 0" class="item-desc" v-html="item.description"></div>
                    </label>
                </div>
            </div>
            <div v-else class="infobox">
                U dospělého psa zde vybíráte, v jaké je aktuální kondici. U štěňat to pro výpočet Pettime není podstatné. Zvolte “Pokračovat”.
            </div>

        </div>

        <info v-if="!mazlicek.jeStene" :krok="6"></info>

        <confirmation-modal v-if="priceConfirmation.showModal"
                            :old-price="priceConfirmation.oldPrice" :new-price="priceConfirmation.newPrice"
                            :confirm-callback="updatePetAndQuit" @close="priceConfirmation.showModal = false"/>
        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, between} from 'vuelidate/lib/validators'
    import {apiSilex} from '../api'
    import navigace from './Navigace'
    import info from './Info'
    import filters from '../filters'
    import ConfirmationModal from "./ConfirmationModal";

    export default {
        components: {ConfirmationModal, navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                mazlicekWeight: this.$store.state.mazlicek.hmotnostkondice.hmotnost,
                kondiceItems: [],
                pHmotnost: 0,
                pHmotnostProc: 30,
                pHmotnostMin: 0,
                pHmotnostMax: 0,
                tryescape: false,
                petWeight: "",
                priceConfirmation: {
                    showModal: false,
                    differentPrice: false,
                    oldPrice: 0,
                    newPrice: 0,
                }
            }
        },
        computed: {
            vahaPlaceholder() {
                return 'Doplňte, jakou má ' + this.mazlicek.jmeno.value + ' hmotnost'
            },
            checkPrumHmotnost: function () {
                var x = (this.pHmotnost / 100) * this.pHmotnostProc
                this.pHmotnostMin = this.pHmotnost - x
                this.pHmotnostMax = this.pHmotnost + x

                const hmotnostKg = this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.petWeight * 0.45359237 : this.petWeight
                if (hmotnostKg > 0) {
                    return (hmotnostKg >= this.pHmotnostMin && hmotnostKg <= this.pHmotnostMax)
                } else {
                    return true
                }
            },
            refreshWeight() {
                // this.petWeight = filters.round(this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.mazlicek.hmotnostkondice.hmotnost / 0.45359237 : this.mazlicek.hmotnostkondice.hmotnost)
                return this.petWeight
            }
        },
        methods: {
            prev: function () {
                this.$router.push({name: 'pohlavi'})
            },
            updatePetAndQuit: function () {
                this.mazlicek.confirmToSave = false
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.mazlicek.hmotnostkondice.valid = true
                    this.mazlicek.pohyb.valid = true
                    this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
            },
            saveAndQuit: function () {
              if (this.isStepValid()) {
                if (this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb') {
                  this.mazlicek.hmotnostkondice.hmotnost = this.petWeight * 0.45359237
                } else {
                  this.mazlicek.hmotnostkondice.hmotnost = this.petWeight
                }

                this.mazlicek.confirmToSave = true
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    const confirmation = response.data.data.priceConfirmation;
                    if (confirmation && confirmation.differentPrice) {
                        this.priceConfirmation.oldPrice = confirmation.oldPrice;
                        this.priceConfirmation.newPrice = confirmation.newPrice;
                        this.priceConfirmation.showModal = true
                    } else {
                        this.updatePetAndQuit()
                    }
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryescape = true
                this.animateAfterError()
              }
            },
            next: function () {
                // this.$store.commit('setMazlicek', this.mazlicek)

                if (this.isStepValid()) {
                    if (this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb') {
                        this.mazlicek.hmotnostkondice.hmotnost = this.petWeight * 0.45359237
                    } else {
                        this.mazlicek.hmotnostkondice.hmotnost = this.petWeight
                    }
                    this.mazlicek.hmotnostkondice.valid = true
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {

                            this.mazlicek.hmotnostkondice.valid = true
                            this.mazlicek.pohyb.valid = true
                            this.$router.push({name: 'pohyb'})
//                            this.$router.push({name: 'alergie'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryescape = true
                    this.animateAfterError()
                }
            },
            isValidHmotnost: function () {
                return this.petWeight !== null && this.petWeight > 0
            },
            isKondiceValid: function () {
                return this.mazlicek.hmotnostkondice.kondice !== null || this.mazlicek.jeStene
            },
            isStepValid: function () {
                return this.isValidHmotnost() && this.isKondiceValid()
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            },
            getAvargeWeight(){
                apiSilex.get('/hmotnost').then(
                    response => (this.kondiceItems = response.data)
                )
                if (this.mazlicek.rasa.typ === 'app_rasa') {
                    var url = '/rasa/' + this.mazlicek.rasa.id + '/pvaha'
                    if (this.mazlicek.pohlavi.value === 'pes') {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.pes))
                        )
                    } else {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.fena))
                        )
                    }
                } else {
                    var url = '/velikost/' + this.mazlicek.rasa.velikost + '/pvaha'
                    if (this.mazlicek.pohlavi.value === 'pes') {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.pes))
                        )
                    } else {
                        apiSilex.get(url).then(
                            response => (this.pHmotnost = parseFloat(response.data.fena))
                        )
                    }
                }
            },
            getPetWeight: function () {
                return filters.round(this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.mazlicek.hmotnostkondice.hmotnost / 0.45359237 : this.mazlicek.hmotnostkondice.hmotnost, 1)
            },
        },
//        beforeUpdate: function () {
//            if (this.mazlicek.hmotnostkondice.hmotnost)
//                this.petWeight = filters.round(this.mazlicek.hmotnostkondice.hmotnostJednostka == 'lb' ? this.mazlicek.hmotnostkondice.hmotnost / 0.45359237 : this.mazlicek.hmotnostkondice.hmotnost)
//        },
        mounted: function () {
            this.mazlicek.step.current = 5
            this.$cookies.set('lastVisitedStep', 5)
            jQuery('html, body').animate({scrollTop: 0}, '500')

            if (this.mazlicek.hmotnostkondice.hmotnost)
                this.petWeight = this.getPetWeight()

            this.getAvargeWeight();
        },
        watch: {
            'mazlicek.petLoaded.value': {
                deep: true,
                handler: function (val) {
                    if (val)
                        this.petWeight = this.getPetWeight()

                    this.getAvargeWeight();
                }
            }
        }
//        validations: {
//            mazlicek: {
//                hmotnostkondice: {
//                    hmotnost: {
//                        required
//                    }
//                }
//            }
//        },
    }
</script>



// WEBPACK FOOTER //
// 06HmotnostKondice.vue?ff2f5f02